import React from 'react';
import { InfoCardVariants, TableColumn } from '@backstage/core-components';
import { EntityTable } from '@backstage/plugin-catalog-react';
import {
  Entity,
  GroupEntity,
  RELATION_HAS_MEMBER,
} from '@backstage/catalog-model';
import { RelatedEntitiesCard } from '../RelatedEntitiesCard/RelatedEntitiesCard';

export interface HasServiceCardProps {
  variant?: InfoCardVariants;
}

export const HasGroupsCard = (props: HasServiceCardProps) => {
  const { variant = 'gridItem' } = props;

  const resourceEntityColumns: TableColumn<GroupEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'group' }),
    EntityTable.columns.createSpecLifecycleColumn(),
  ];

  const asGroupEntities = (entities: Entity[]): GroupEntity[] =>
    entities as GroupEntity[];

  return (
    <RelatedEntitiesCard
      variant={variant}
      title={'Groups'}
      entityKind="Group"
      relationType={RELATION_HAS_MEMBER}
      columns={resourceEntityColumns}
      asRenderableEntities={asGroupEntities}
    />
  );
};
